import SEGMENT_TRACKING_EVENTS from 'constants/segmentEvents';

function SignUpCtrl($state, $stateParams, sdkAuthService, sdkUtils, $timeout, analyticsService, managementUserService, authService) {
  const vm = this;

  authService.logout();

  vm.signUpForm = {
    email: $stateParams.email ? $stateParams.email : null
  };
  vm.signUp = _signUp;

  /**
   * @desc Log a user in
   * @param {Object} form - Angular form object
   * @param {Object} [$event] - Angular event object
   */
  function _signUp(form, $event) {
    if (!form) throw new Error('form is required');
    if ($event) $event.preventDefault();

    vm.submitted = true;

    if (!form.$valid) return null;

    vm.saving = true;

    return sdkAuthService.register({
        firstName: vm.signUpForm.firstName,
        lastName: vm.signUpForm.lastName,
        email: vm.signUpForm.email,
        password: vm.signUpForm.password
      })
      .then(() => {
        analyticsService.trackEvent(SEGMENT_TRACKING_EVENTS.REGISTERED);

        return managementUserService.me()
          .then(() => {
            $state.go('app.accountSetup', {
              signUpVersion: vm.signUpVersion
            });
          });
      })
      .catch(response => {
        vm.errorMsg = sdkUtils.getErrorFromResponse(response);

        $timeout(() => {
          vm.errorMsg = null;
        }, 6000);
      })
      .finally(() => {
        vm.saving = false;
      });
  }
}

SignUpCtrl.$inject = [
  '$state',
  '$stateParams',
  'jsSdk.auth',
  'jsSdk.utils',
  '$timeout',
  'analyticsService',
  'jsSdk.managementUser',
  'authService'
];

export default SignUpCtrl;



// WEBPACK FOOTER //
// ./src/components/signUp/signUpCtrl.js